import { createElement, Fragment } from "react";
import { renderChildren } from "./renderChildren.js";
import { resolveRichTextElementMetadata } from "./resolveRichTextElementMetadata.js";
import { useRichTextRenderMetadata } from "./RichTextRenderMetadataContext.js";
const getElementDataAttributes = (element, attributeNamePrefix = "contember-") => {
  const { children, referenceId, ...extendedSpecifics } = element;
  return Object.fromEntries(Object.entries(extendedSpecifics).filter(([, value]) => {
    const t = typeof value;
    return t === "string" || t === "number" || t === "boolean";
  }).map(([attribute, value]) => [`data-${attributeNamePrefix}${attribute.toLowerCase()}`, value]));
};
function RenderElementFallback({ element, children, options }) {
  const attributes = getElementDataAttributes(element, options.attributeNamePrefix);
  switch (element.type) {
    case "anchor":
      return /* @__PURE__ */ createElement("a", {
        ...attributes,
        href: element.href
      }, children);
    case "heading":
      return createElement(`h${element.level}`, attributes, children);
    case "horizontalRule":
      return /* @__PURE__ */ createElement("hr", {
        ...attributes
      });
    case "listItem":
      return /* @__PURE__ */ createElement("li", {
        ...attributes
      }, children);
    case "orderedList":
      return /* @__PURE__ */ createElement("ol", {
        ...attributes
      }, children);
    case "paragraph":
      return /* @__PURE__ */ createElement("p", {
        ...attributes
      }, children);
    case "reference": {
      return /* @__PURE__ */ createElement(ReferenceElementFallback, {
        element,
        children
      });
    }
    case "scrollTarget":
      return /* @__PURE__ */ createElement("span", {
        ...attributes,
        id: element.identifier
      }, children);
    case "table": {
      const firstRow = element.children[0];
      if (!firstRow || firstRow.headerScope !== "table") {
        return /* @__PURE__ */ createElement("table", {
          ...attributes
        }, /* @__PURE__ */ createElement("tbody", null, children));
      }
      return /* @__PURE__ */ createElement("table", {
        ...attributes
      }, /* @__PURE__ */ createElement("thead", null, renderChildren([firstRow], options)), /* @__PURE__ */ createElement("tbody", null, renderChildren(element.children.slice(1), options)));
    }
    case "tableRow":
      return /* @__PURE__ */ createElement("tr", {
        ...attributes
      }, children);
    case "tableCell": {
      if (element.headerScope) {
        return /* @__PURE__ */ createElement("th", {
          ...attributes,
          scope: element.headerScope
        }, children);
      }
      return /* @__PURE__ */ createElement("td", {
        ...attributes
      }, children);
    }
    case "unorderedList":
      return /* @__PURE__ */ createElement("ul", {
        ...attributes
      }, children);
    default: {
      {
        return children;
      }
    }
  }
}
function ReferenceElementFallback({ element, children }) {
  const metadata = useRichTextRenderMetadata();
  const elementMetadata = resolveRichTextElementMetadata(element, metadata);
  if (elementMetadata.referenceRenderer === void 0 || elementMetadata.referenceType === void 0 || elementMetadata.reference === void 0) {
    {
      return children;
    }
  }
  return /* @__PURE__ */ createElement(Fragment, null, elementMetadata.referenceRenderer?.({
    referenceType: elementMetadata.referenceType,
    referenceRenderer: elementMetadata.referenceRenderer,
    reference: elementMetadata.reference,
    formatVersion: elementMetadata.formatVersion,
    element,
    children
  }));
}
export { RenderElementFallback };
//# sourceMappingURL=RenderElementFallback.js.map
